// Lazily loads pdfmake + fonts + html-to-pdfmake from CDN on first use.
// These are only needed for the "Download PDF" feature (actions.js/compare-button.js),
// so loading them eagerly on every page visit — as <script> tags in index.html — delayed
// bms-pre.js (and the search UI it renders) for every visitor, most of whom never click Download.

let loadPromise = null;

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
    });
}

export function ensurePdfLibsLoaded() {
    if (!loadPromise) {
        loadPromise = (async () => {
            // Order matters: vfs_fonts.js patches the global pdfMake.vfs, so pdfmake
            // must already exist; html-to-pdfmake doesn't depend on either at load time.
            await loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/pdfmake.min.js');
            await loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/vfs_fonts.js');
            await loadScript('https://unpkg.com/html-to-pdfmake/browser.js');
        })();
    }
    return loadPromise;
}
